import { render } from "./HeatingBenefit.vue?vue&type=template&id=0b2a09ee&scoped=true"
import script from "./HeatingBenefit.vue?vue&type=script&lang=js"
export * from "./HeatingBenefit.vue?vue&type=script&lang=js"

import "./HeatingBenefit.vue?vue&type=style&index=0&id=0b2a09ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2a09ee"]])

export default __exports__